<ion-tabs>
  <ion-tab-bar slot="bottom">
    <ion-tab-button tab="home" href="/home">
      <div [ngClass]="{'active': isHomeActive()}">
        <img [src]="isHomeActive() ? '/assets/icons/home.svg' : '/assets/icons/home-white.svg'" />
      </div>
    </ion-tab-button>

    <ion-tab-button tab="wallets" href="/wallets">
      <div [ngClass]="{'active': isWalletActive()}">
        <img [src]="isWalletActive() ? '/assets/icons/wallet.svg' : '/assets/icons/wallet-white.svg'" />
      </div>
    </ion-tab-button>

    <ion-tab-button tab="events" href="/events">
      <div [ngClass]="{'active': isEventActive()}">
        <img [src]="isEventActive() ? '/assets/icons/event.svg' : '/assets/icons/event-white.svg'" alt="Event Icon" />
      </div>
    </ion-tab-button>

    <ion-tab-button tab="rewards" href="/rewards">
      <div [ngClass]="{'active': isRewardsActive()}">
        <img [src]="isRewardsActive() ? '/assets/icons/rewards.svg' : '/assets/icons/rewards-white.svg'" />
      </div>
    </ion-tab-button>

    <ion-tab-button tab="profile" href="/profile">
      <div [ngClass]="{'active': isProfileActive()}">
        <img [src]="isProfileActive() ? '/assets/icons/profile-icon.svg' : '/assets/icons/profile-white.svg'" />
      </div>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>